import { ENDPOINTS, connectWithHammock } from 'hammock';
import React, { useEffect } from 'react';

import { useEventing } from 'commons/eventing';

import TemplateList from './TemplateList';

interface Props {
  documentId?: number;
}

const TemplatesTabContent = ({ documentId }: Props) => {
  const eventing = useEventing();
  useEffect(() => {
    eventing.screen('editor.view.templateModal');
  }, []);

  if (!documentId) {
    return null;
  }

  return <TemplateList documentId={documentId} />;
};

export const TemplatesTab = connectWithHammock({
  endpoint: ENDPOINTS.templateMetadata,
})(TemplatesTabContent);
